<template>
  <section class="section container pt-3">
    <div class="mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("renap module settings") }}
      </h1>
    </div>

    <!-- <div class="tabs is-toggle is-fullwidth" ref="tabs">
      <ul>
        <li
          class="is-active"
          data-tab="profiles"
          @click="change_active_tab($event, this)"
        >
          <a>
            <i class="user icon" aria-hidden="true"></i>
            <span>{{ $t("connection profiles") }}</span>
          </a>
        </li>
        <li data-tab="processes" @click="change_active_tab($event, this)">
          <a>
            <i class="list icon" aria-hidden="true"></i>
            <span>{{ $t("processes") }}</span>
          </a>
        </li>
      </ul>
    </div> -->
    <!-- <div class="is-fluid" ref="contents"> -->
    <!-- <div class="" data-tab="profiles"> -->
    <profiles-datatable />
    <token-datatable />
    <!-- </div> -->
    <!-- <div class="is-hidden" data-tab="processes">
        <processes-datatable class="" />
      </div>
    </div> -->

    <!-- <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div> -->
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  success_message,
  error_message,
  change_active_tab,
} from "@/utils";
import { isEmpty } from "lodash";
import { v4 } from "uuid";
import ProfilesDatatable from "./profiles_datatable/Index.vue";
import TokenDatatable from "./token_datatable/Index.vue";
// import ProcessesDatatable from "./processes_datatable/Index.vue";

export default {
  name: "RenapSettings",
  components: { ProfilesDatatable, TokenDatatable },
  data() {
    return {
      meta: { profiles: [] },
    };
  },
  methods: {
    change_active_tab,
    save() {
      let v = this;
      let data = { ...v.meta };
      v.$root.loader(true);
      save_configuration(v, data)
        .then(() => {
          success_message(v.$t("configuration saved"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    create() {
      let v = this;
      v.meta.profiles.push({ uuid: v4(), name: v.$t("new profile") });
    },
    configure_profile(profile) {
      let v = this;
      v.$refs.profile_modal.show_modal(profile);
    },
    profile_modified(profile) {
      let v = this;
      let trgt = v.meta.profiles.find((p) => p.uuid === profile.uuid);
      if (trgt) {
        Object.keys(profile).map((k) => {
          trgt[k] = profile[k];
        });
      }
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf && !isEmpty(conf)) v.meta = conf;
      })
      .catch((error) => {
        error_message(error);
      })
      .finally(() => {
        v.$root.loader(false);
      });
  },
};
</script>

<style></style>
